import api from './HttpService';
import { REPORT } from '../configs/ApiActionUrl';

// async function getAll(pageOption, sortData, keyword, departmentName) {
//   let query = '';

//   if (pageOption) {
//     const { page, pageSize } = pageOption;
//     if (page !== undefined && pageSize !== undefined) {
//       query = `?page=${page + 1}&limit=${pageSize}`;
//     }
//   }

//   if (sortData) {
//     const { sortField, sort } = sortData;
//     if (sortField && sort) {
//       query += `&sort_by=${sortField}&order_by=${sort}`;
//     }
//   }

//   if (keyword) {
//     query += `&search_key=${keyword}`;
//   }

//   if (departmentName) {
//     query += `&department_name=${departmentName}`;
//   }

//   try {
//     const res = await api.get(REPORT.SUMMARY_LIST + query);
//     return res;
//   } catch (error) {
//     // Handle errors here
//     return error; // Rethrow the error to propagate it further
//   }
// }

async function getSummaryReport(postData) {
  const res = await api.post(REPORT.SUMMARY_LIST, postData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res;
}

async function getSummaryFilters() {
  const res = await api.get(`${REPORT.SUMMARY_FILTER}`);
  return res;
}

async function getAgeingReport(postData) {
  const res = await api.post(REPORT.AGEING_LIST, postData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res;
}

async function getAgeingFilters() {
  const res = await api.get(`${REPORT.AGEING_FILTER}`);
  return res;
}

async function getFilters() {
  const res = await api.get(`${REPORT.FILTER}`);
  return res;
}

async function clientBasedReport(postData) {
  const res = await api.post(`${REPORT.CLIENT_BASED}`, postData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res;
}

async function deptBasedReport(postData) {
  const res = await api.post(`${REPORT.DEPARTMENT_BASED}`, postData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res;
}

const reportService = {
  getSummaryReport,
  clientBasedReport,
  getFilters,
  getSummaryFilters,
  deptBasedReport,
  getAgeingFilters,
  getAgeingReport
};

export default reportService;
